// Export the Component Definition for use in Contentful Studio
export {ActivityCarouselContentfulComponentDefinition} from './ActivityCarouselContentfulDefinition';
export type {ActivityCarouselProps, ActivityEntry} from './ActivityCarousel';
export {default} from './ActivityCarousel';
